export const CSS_CLASSES = {
	SELECTION_MULTISELECT_CONTAINER: 'multiselect--selections__container',
	SELECTION_MULTISELECT_CONTAINER_LONG_TITLE:
		'multiselect--selections__container__title--long',
	SELECTION_MULTISELECT_CONTAINER_SHORT_TITLE:
		'multiselect--selections__container__title--short',
	INLINE_SELECTION_MULTISELECT_CONTAINER:
		'multiselect--selections__container--inline',
	STICKY_SELECTION_MULTISELECT_CONTAINER:
		'multiselect--selections__container--sticky',
	WARNING: 'warning',
};
